/**
 * @voltxampere/components — Inductor definition
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
export const InductorParamsSchema = z
    .object({
    /** Inductance in henries; strictly positive. */
    inductance: z.number().positive().finite(),
    /** Initial current through the inductor at t=0; defaults to 0. */
    initialCurrent: z.number().finite().optional(),
    /** Optional series resistance for non-ideal inductors. */
    seriesResistance: z.number().nonnegative().finite().optional(),
})
    .strict();
export const inductorDefinition = {
    type: "inductor",
    category: "passive",
    displayName: { tr: "Bobin", en: "Inductor" },
    symbol: "L",
    pins: [
        { id: "p1", side: "left", offset: 0, label: "1" },
        { id: "p2", side: "right", offset: 0, label: "2" },
    ],
    parameterSchema: InductorParamsSchema,
    nonlinear: false,
};
//# sourceMappingURL=inductor.js.map